module.exports = __webpack_public_path__ + "static/img/fenzuhanhua.cfca17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/fenzuhanhua.png
// module id = YbPF
// module chunks = 24